module.exports = __webpack_public_path__ + "img/图片3.72ff9bef.png";